import { type ReactNode } from 'react';
import type { TeamMember } from '../types';
import { StatusBadge } from './status-badge';

function CreatorsCount({ count }: { count: number }): ReactNode {
  if (!count) return null;
  return (
    <span className="inline-flex rounded-full bg-brand-red px-2 py-0.5 text-[11px] font-medium text-white">
      {count} creadores
    </span>
  );
}

export function TopChips({ member }: { member: TeamMember }): ReactNode {
  return (
    <div className="absolute left-sm top-sm flex flex-col items-start gap-xs md:contents">
      <div className="md:absolute md:left-sm md:top-sm">
        <StatusBadge
          status={member.account_status}
          test_passed_at={member.test_passed_at}
          vacation_starts_at={member.vacation_starts_at}
          vacation_ends_at={member.vacation_ends_at}
        />
      </div>
      <div className="md:absolute md:right-sm md:top-sm">
        <CreatorsCount count={member.leads_count ?? 0} />
      </div>
    </div>
  );
}
